import { Helmet } from "react-helmet-async";
import { useEffect, useRef } from "react";
import Header from "../../page-elements/Header";

const APIDocsPage = () => {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current || window.customElements.get("elements-api")) return;

    const script = document.createElement("script");
    script.src = "https://unpkg.com/@stoplight/elements/web-components.min.js";
    script.async = true;
    document.head.appendChild(script);
    loaded.current = true;

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>API Docs | Coursable - personal AI study guide</title>
        <link rel="stylesheet" href="https://unpkg.com/@stoplight/elements/styles.min.css" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="flex flex-col w-screen h-screen overflow-auto">
        <Header />
        <main className="flex items-start justify-center h-full overflow-auto bg-[rgb(235,_238,_245)] w-full">
          {/* @ts-ignore: web component */}
          <elements-api style={{ width: "100%", maxWidth: "1920px", height: "100%" }} apiDescriptionUrl="/OpenAPI.json" router="hash" layout="sidebar" />
        </main>
      </div>
    </>
  );
};

export default APIDocsPage;
